import { Component, OnInit } from '@angular/core';
import { CompanyService, Company } from "app/services/company.service";
import { Router, ActivatedRoute } from "@angular/router/";
import { BaseComponent } from "app/components/base.component";

declare var $: any;

@Component({
	selector: 'app-companies-bulk',
	templateUrl: './companies-bulk.component.html',
	styleUrls: ['./companies-bulk.component.css']
})
export class CompaniesBulkComponent extends BaseComponent implements OnInit {

	formTitle: string = "Bulk Add Companies";
	buttonText: string = "Upload CSV File";
	csvSelector: string = "csv-files";
	companiesBulk: Company[] = [];
	notif_msg:string = '';
	notif_type: string = "text-success";
	show_table: string = "";
	ok_to_upload: string = "";

	constructor(
		private companyService: CompanyService,
		private router: Router,
		private route: ActivatedRoute,
	) {
		super();
	}

	ngOnInit() {
	}

	formAction() {
		var self = this;
		var complete = 0;
		this.companiesBulk.forEach(element => {
			this.companyService.addCompany(element).then(result => {
				complete++;
				if(complete >= self.companiesBulk.length) {
					this.companiesBulk = [];
					var form_element = <HTMLFormElement>document.getElementById("form-"+this.csvSelector);
					form_element.reset();
					this.notif_msg = "Data has been successfully added";
					this.notif_type = "text-success";
					// self.router.navigate(['/company']);
				}
			})
		});
	}

	filechange(event: Event) {
		var self = this;
		var input = <HTMLInputElement>event.target;
		var file_name_element = <HTMLSpanElement>document.getElementById("file-used-"+self.csvSelector);
		var form_element = <HTMLFormElement>document.getElementById("form-"+self.csvSelector);
		this.notif_msg = '';
		var file = input.files[0];
		var r = new FileReader();
		r.readAsText(file);
		r.onloadend = function (e) {
			self.companiesBulk = [];
			file_name_element.innerHTML = file.name;
			form_element.reset();
			var csvData = r.result;
			try {
				var data = $.csv.toArrays(csvData);
				if (data && data.length > 0) 
				{
					var is_csv_valid = true;
					data.forEach(element => {
						element.forEach(array_element => {
							if(!array_element)
							{
								is_csv_valid = is_csv_valid && false;
							}
						});
						var data_list = {
							name: element[0] || null,
							street_one: element[1] || null, 
							street_two: element[2] || null,
							city: element[3] || null,
							postal_code: element[4] || null,
							country_key: element[5] || null,
							phone: element[6] || null,
							fax: element[7] || null,
							email: element[8] || null,
							attn: element[9] || null,
							type: element[10] || null,
						};
						self.companiesBulk.push(Object.assign(new Company(), data_list));
					});
					if(!is_csv_valid)
					{
						self.notif_msg = "Some Fields are Empty";
						self.notif_type = "text-danger";
						self.show_table = "show-table"; 
						self.ok_to_upload = "ok_to_upload";
					}
					else
					{
						self.notif_msg = "";
						self.notif_type = "text-success";
						self.show_table = "show-table"; 
					}
				}
				else
				{
					self.show_table = ""; 
					self.notif_msg = "Empty file";
					self.notif_type = "text-danger";
				}	
			} catch (error) {
				self.show_table = ""; 
				self.ok_to_upload = "";
				self.notif_msg = "Please upload CSV file.";
				self.notif_type = "text-danger";
			}
		}	
	}

	trackByIndex(index: number, obj: any): any {
		return index;
	}
	
	onDeleteClick(index)
	{
		if(confirm('Are you sure?'))
		{
			this.companiesBulk.splice(index, 1);
		}
	}
}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/company/companies-bulk/companies-bulk.component.ts